import "./css/IntroPage.css";
import { companyDetails } from "./data/solutions"

const Solutions = () => {
    return (
        <>

            <div className="company-product-container main-content">
                <div id="intro-company" className="company-container">
                    <h1 className="center-label auto-show mb-2 brand-text">
                        Solutions
                    </h1>
                    <p className="para text-center">Proven experience in BI, CRM, ERP and DataIntegration space across different industry domains</p>

                    <div className="company-detail-container row">
                        {companyDetails.map((item, index) => (
                            <div key={index} className="col-xxl-12 col-lg-4 col-sm-12 col-xs-12 company-main p-2">
                                <div className="company-detail-item columnwise-flex">
                                    <div
                                        className="company-detail-img mt-3"
                                        style={{ backgroundImage: `url(${item.image})` }}
                                    >

                                    </div>
                                    <div className="text-align-left mt-2">
                                        <div className="overlay-label">{item.title}</div>
                                    </div>
                                    <div className="company-detail-content">{item.content}</div>
                                    <div className="bottom-hover-line mt-3"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


            </div>

        </>
    );
}

export default Solutions;